import React, { ReactNode } from 'react';
import classes from './ResourceCard.module.scss';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `none`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  height: 0,
  minHeight: 0,
  overflow: 'hidden',
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '16px',
  border: '1px solid var(--color-greyscale-100)',
  '&.MuiCollapse-hidden': {
    border: 'none',
  },
}));

interface DependenciesProps {
  InnerView?: ReactNode;
  expanded?: boolean;
}

export const Dependencies = (props: DependenciesProps) => {
  return (
    <Accordion slotProps={{ transition: { unmountOnExit: true } }} expanded={props.expanded}>
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Typography>Collapsible Group Item #1</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.dependenciesContainer}>
        {props.InnerView}
      </AccordionDetails>
    </Accordion>
  );
};
